import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";

// Self-hosted fonts (needed so COEP: require-corp doesn't block Google Fonts)
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/600.css";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/jetbrains-mono/400.css";

import "./index.css";
import Record from "./pages/Record";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import AdminVideo from "./pages/AdminVideo";
import Home from "./pages/Home";
import CrmLayout from "./pages/crm/CrmLayout";
import CrmToday from "./pages/crm/Today";
import CrmEstrellas from "./pages/crm/Estrellas";
import CrmTouchpoints from "./pages/crm/Touchpoints";
import CrmBatches from "./pages/crm/Batches";
import CrmLeads from "./pages/crm/Leads";
import CrmLeadDetail from "./pages/crm/LeadDetail";
import CrmSettings from "./pages/crm/Settings";

const router = createBrowserRouter([
  { path: "/", element: <Home /> },
  { path: "/r/:linkId", element: <Record /> },
  { path: "/admin", element: <Admin /> },
  { path: "/admin/login", element: <AdminLogin /> },
  // Legacy redirect for old AdminList path
  { path: "/admin/videos", element: <Navigate to="/admin#videos" replace /> },
  { path: "/admin/videos/:videoId", element: <AdminVideo /> },
  // CRM dashboard (sub-path, no separate sub-domain)
  {
    path: "/crm",
    element: <CrmLayout />,
    children: [
      { index: true, element: <Navigate to="today" replace /> },
      { path: "today", element: <CrmToday /> },
      { path: "estrellas", element: <CrmEstrellas /> },
      { path: "touchpoints", element: <CrmTouchpoints /> },
      { path: "batches", element: <CrmBatches /> },
      { path: "leads", element: <CrmLeads /> },
      { path: "leads/:id", element: <CrmLeadDetail /> },
      { path: "settings", element: <CrmSettings /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
